"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachSinkId = void 0;
function setSinkId(element, sinkId) {
    element.setSinkId(sinkId)
        .then(() => {
        // console.log("Audio destination for " + name + " updated succesfully", "success")
        sinkIdMap[element.id] = sinkId;
    })
        .catch((error) => {
        let errorMessage = error;
        if (error.name === 'SecurityError') {
            errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
        }
        console.error(errorMessage + " for " + element.id, "error");
    });
}
let debug = false;
// used to check if setting twice the same sinkId
const sinkIdMap = {};
// Attach audio output device to video element using device/sink ID.
function attachSinkId(name, element, sinkId) {
    if (debug)
        console.log("setting stream", name, element, sinkId);
    try {
        if ((element) === undefined) {
            console.warn('attempting to route undefined element to sink id %s', sinkId);
            return;
        }
        if (typeof element.sinkId !== 'undefined') {
            if (sinkIdMap[element.id] == sinkId) {
                // As it is setting the same sinkID, crome doesnt route the audio appropiately
                // we must set it to default first, then attempt to set the new sinkId
                // console.log("setting default first")
                element.setSinkId('default').then(() => {
                    // console.log("setting stream after default")
                    setSinkId(element, sinkId);
                }).catch((error) => {
                    console.error('Error attaching sink Id to element %s: %s', name, error);
                });
            }
            else {
                setSinkId(element, sinkId);
            }
        }
        else {
            console.warn('Browser does not support output device selection.');
        }
    }
    catch (e) {
        console.error('Error attaching sink Id: %s', e);
    }
}
exports.attachSinkId = attachSinkId;
